/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
};

export const attendanceMetricsTypeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.ATTENDANCE_METRICS_TYPE + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTENDANCE_METRICS_TYPE + '_RESULT':
      return {
        ...state,
        data: action.result.data?.data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTENDANCE_METRICS_TYPE + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
